export default "__VITE_ASSET__DFj4Vejb__"